<template>
  <div>
    <div v-if="Lib.checkPower('beauty-2-lpck',2)" class="roundCard">
      <el-radio-group v-model="activeIndex" style="margin: 0 20px 20px 0;float: left;" @change="handleSelect">
        <el-radio-button label="1">全部({{ roundCardList.allNum }})</el-radio-button>
        <el-radio-button label="2">空闲中({{ roundCardList.freeNum }})</el-radio-button>
        <el-radio-button label="3">服务中({{ roundCardList.serviceNum }})</el-radio-button>
        <el-radio-button label="4">预约将到({{ roundCardList.bookNum }})</el-radio-button>
        <el-radio-button label="5">有事暂离({{ roundCardList.leaveNum }})</el-radio-button>
        <el-radio-button label="6">休息中({{ roundCardList.restNum }})</el-radio-button>
      </el-radio-group>
      <div class="screen">
        <el-select v-model="roundCardId" style="width: 240px;margin-right: 20px;" placeholder="请选择轮牌" @change="rcNameChange" @visible-change="showMenu">
          <el-option value="" label="全部轮牌名称"></el-option>
          <el-option v-for="(v,n) in brandTypeList" :key="n" :label="v.cardName" :value="v.id">{{ v.cardName }}</el-option>
        </el-select>
        <el-select v-model="roundCardProject" :disabled="roundCardId == '2' ? true : false" style="width: 240px;margin-right: 20px;" placeholder="请选择项目" @change="rcProjectChange" @visible-change="showMenu">
          <el-option key="" label="全部项目" value=""></el-option>
          <el-option v-for="(a,b) in itemList" :key="b" :label="a.name" :value="a.id"></el-option>
        </el-select>
      </div>
      <div class="screenTwo">
        <p><span class="sp1"></span>空闲中</p>
        <p><span class="sp2"></span>服务中</p>
        <p><span class="sp3"></span>预约将到</p>
        <p><span class="sp4"></span>有事暂离</p>
        <p><span class="sp4"></span>休息中</p>
      </div>

      <div id="roundCard" v-loading="loading" class="roundCardlist">
        <ul v-for="(v,n) in roundCardList.cards" v-show="v.technicianCards.length > 0" :key="n">
          <p>{{ v.cardName }}</p>
          <li v-for="(a,b) in v.technicianCards" :key="b" :class="a.state == 1 ? 'lfour' : a.state == 2 ? 'ltwo' : a.state == 3 ? 'lthree' : a.state == 0 ? 'lone' : 'lfive'" @click="getTechnicianInfo(a.id,a.technicianName,$event,v.technicianCards.length == (b+1))">
            <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
              <div slot="content">
                <p>{{ a.jobNumber }}</p>
              </div>
              <h1 @mouseover="tooltipStatus = Lib.textShow($event,18)">{{ a.jobNumber || '--' }}</h1>
            </el-tooltip>
            <h2>{{ a.technicianName || '--' }}</h2>
            <h6 v-if="a.state != 0 && (v.cardName !== '休息牌')">
              <span>{{ a.message }}</span>
              <positive-time v-if="a.lastTime" :message="a.message" :start-time="a.dateTime" :end-time="a.lastTime" @refresh="refresh"></positive-time>
            </h6>
            <h6 v-if="v.cardName === '休息牌'">
              <label>{{ a.state == 4 ? '请假' : a.state == 5 ? '休假' : (a.message || '--') }}</label>
            </h6>
          </li>
        </ul>
        <!-- <ul v-if="roundCardList.isNotTechnicianCards.length > 0">
                <p>非{{Lib.collectively()}}牌</p>
                <li v-for="(a,b) in roundCardList.isNotTechnicianCards" :key="b" :class="a.state == 1 ? 'lfour' : a.state == 2 ? 'ltwo' : a.state == 3 ? 'lthree' : a.state == 0 ? 'lone' : 'lfive'" @click="getTechnicianInfo(a.id,a.technicianName,$event,roundCardList.isNotTechnicianCards.length == (b+1))">
                    <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                        <div slot="content">
                            <p>{{a.jobNumber}}</p>
                        </div>
                        <h1 @mouseover="tooltipStatus = Lib.textShow($event,18)">{{a.jobNumber || '--'}}</h1>
                    </el-tooltip>
                    <h2>{{a.technicianName || '--'}}</h2>
                    <h6 v-if="a.state != 0">
                        <span>{{a.message}}</span>
                        <positive-time v-if="a.lastTime" :message="a.message" :startTime="a.dateTime" :endTime="a.lastTime"></positive-time>
                    </h6>
                </li>
            </ul> -->
        <!-- <ul v-if="roundCardList.freeTechnicianCards.length > 0">
                <p>休息牌</p>
                <li v-for="(a,b) in roundCardList.freeTechnicianCards" :key="b" :class="a.state == 1 ? 'lfour' : a.state == 2 ? 'ltwo' : a.state == 3 ? 'lthree' : a.state == 0 ? 'lone' : 'lfive'" @click="getTechnicianInfo(a.id,a.technicianName,$event,roundCardList.freeTechnicianCards.length == (b+1))">
                    <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
                        <div slot="content">
                            <p>{{a.jobNumber}}</p>
                        </div>
                        <h1 @mouseover="tooltipStatus = Lib.textShow($event,18)">{{a.jobNumber || '--'}}</h1>
                    </el-tooltip>
                    <h2>{{a.technicianName || '--'}}</h2>
                    <h6>
                        <label>{{a.state == 4 ? '请假' : a.state == 5 ? '休假' : (a.message || '--')}}</label>
                    </h6>
                </li>
            </ul> -->
        <gt-noneData v-show="roundCardList.cards.length == 0 && loading == false" :title="'暂无轮牌数据'"></gt-noneData>
      </div>
      <div id="roundCardMenu" style="display: none">
        <ul>
          <li v-if="getClassName == 'lone' || getClassName == 'ltwo'" @click="chooseCard('扣牌')">扣牌</li>
          <li v-if="getClassName == 'lthree'" @click="chooseCard('复牌')">复牌</li>
          <li v-if="getClassName != '' && getClassName != 'lfive' && !lastCardStatus" @click="chooseCard('跳尾牌')">跳尾牌</li>
          <li v-if="getClassName == 'lone' || getClassName == 'ltwo' || getClassName == 'lthree'" @click="chooseCard('下牌')">下牌</li>
          <li v-if="getClassName == 'lfive'" @click="chooseCard('上牌')">上牌</li>
        </ul>
      </div>
      <el-dialog :title="chooseCardName" :visible.sync="cardDialog" :append-to-body="true" width="580px">
        <el-form ref="ruleForm" :model="ruleForm" label-width="100px" class="demo-ruleForm" :rules="rules">
          <el-form-item label="员工名字：">
            <span>{{ chooseTechnicianName }}</span>
          </el-form-item>
          <el-form-item v-if="chooseCardName == '下牌'" label="下牌类型：" prop="playCardType" required>
            <el-select v-model="ruleForm.playCardType" style="width: 240px;" placeholder="请选择">
              <el-option value="4" label="请假">请假</el-option>
              <el-option value="5" label="休假">休假</el-option>
              <el-option value="6" label="其他">其他</el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="chooseCardName == '扣牌'" label="扣牌原因：" prop="cardDeductionReason" required>
            <el-input v-model="ruleForm.cardDeductionReason" style="width: 240px;" maxlength="6" placeholder="6个字以内"></el-input>
          </el-form-item>
          <el-form-item v-if="chooseCardName == '下牌' && ruleForm.playCardType == '6'" label="下牌事由：" prop="playCardReason" required>
            <el-input v-model="ruleForm.playCardReason" style="width: 240px;" maxlength="10" placeholder="10个字以内"></el-input>
          </el-form-item>
          <el-form-item v-if="chooseCardName == '下牌' && ruleForm.playCardType != '6'" :label="ruleForm.playCardType == '4' ? '请假时间：' : '休假时间：'" prop="leaveTime" required>
            <el-date-picker v-model="ruleForm.leaveTime" style="width: 350px;" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm" format="yyyy-MM-dd HH:mm" :default-time="['12:00:00', '12:00:00']" :editable="false">
            </el-date-picker>
          </el-form-item>
          <el-form-item v-if="chooseCardName == '下牌' && ruleForm.playCardType != '6'" :label="ruleForm.playCardType == '4' ? '请假事由：' : '休假事由：'">
            <el-input v-model="ruleForm.leaveReason" style="width: 414px;" :autosize="{ minRows: 2, maxRows: 4}" type="textarea" placeholder="100个字以内" maxlength="100">
            </el-input>
          </el-form-item>
          <el-form-item>
            <div style="float: right;">
              <el-button @click="cardDialog = false">取 消</el-button>
              <el-button type="primary" @click="comfirmSubmit('ruleForm')">确 定</el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>

<script>
import {
  getErpTechnicianCard, getItemByMainId, deductCard, downCard, jumpCard, resumeCard, upCard, getCardsByMainId
} from './api';
import PositiveTime from './template/positiveTime';
// 计时组件
export default {
  components: {
    PositiveTime
  },
  data() {
    return {
      activeIndex: '1', // tab栏的值
      roundCardId: '', // 轮牌Id
      roundCardProject: '', // 轮牌项目
      screenWidth: document.body.clientWidth, // 屏幕宽度
      timer: false, // 监听窗口变化--防止多次触发
      getClassName: '', // 右键获得的class名
      cardDialog: false, // 选择的操作功能--弹窗
      chooseCardName: '', // 选择的操作功能--扣牌，复牌，跳尾牌，下牌，上牌
      ruleForm: {
        playCardType: '6', // 下牌类型
        cardDeductionReason: '', // 扣牌原因
        playCardReason: '', // 下牌事由
        leaveTime: [], // 请假时间
        leaveReason: '', // 请假事由
      },
      rules: { // 请假表单提示和规则
        playCardType: [
          { required: true, message: '请选择下牌类型', trigger: 'blur' },
          { required: true, message: '请选择下牌类型', trigger: 'change' }
        ],
        playCardReason: [
          { required: true, message: '请填写下牌事由', trigger: 'blur' },
          { required: true, message: '请填写下牌事由', trigger: 'change' }
        ],
        leaveTime: [
          {
            type: 'array',
            required: true,
            message: '请选择请/休假时间',
            trigger: 'change'
          },
          {
            type: 'array',
            required: true,
            message: '请选择请/休假时间',
            trigger: 'blur'
          }
        ],
        cardDeductionReason: [
          { required: true, message: '请填写扣牌原因', trigger: 'blur' },
          { required: true, message: '请填写扣牌原因', trigger: 'change' }
        ],
      },
      chooseTechnicianId: '', // 选择操作的统称ID
      chooseTechnicianName: '', // 选择操作的统称名称
      itemList: [], // 项目列表
      roundCardList: {
        allNum: 0,
        bookNum: 0,
        freeNum: 0,
        cards: [],
        freeTechnicianCards: [],
        leaveNum: 0,
        restNum: 0,
        serviceNum: 0,
      }, // 轮牌数据
      loading: true, // 加载动画
      tooltipStatus: false, // 气泡显示
      lastCardStatus: false, // 跳尾牌状态

      // 5.7
      brandTypeList: [],
    };
  },
  watch: {
    // 窗口宽度变化
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        const vm = this;
        setTimeout(() => {
          vm.timer = false;
        }, 400);
      }
    },
    // 扣牌，复牌，跳尾牌，下牌，上牌--弹出窗口状态
    cardDialog(val) {
      const vm = this;
      if (!val) {
        setTimeout(() => {
          vm.ruleForm.leaveTime = []; // 请假时间
          vm.ruleForm.leaveReason = ''; // 请假事由
          vm.ruleForm.playCardReason = ''; // 下牌事由
          vm.ruleForm.playCardType = '6'; // 下牌类型
          vm.ruleForm.cardDeductionReason = ''; // 扣牌原因
        }, 300);
        setTimeout(() => {
          vm.$refs.ruleForm.resetFields();
          vm.$refs.ruleForm.clearValidate();
        }, 500);
      }
    },
  },
  mounted() {
    $(document).on('click touchstart', (e) => {
      const target = $(e.target);
      if (target.closest('#roundCard ul li').length == 0) { // 点击id为roundCardMenu之外的地方触发
        $('#roundCardMenu').hide();
      }
    });
  },
  activated() {
    const vm = this;
    vm.getItemData();
    vm.getBrandTypeList();
    vm.getTechnicianCardData();
    window.addEventListener('resize', () => {
      vm.screenWidth = document.body.clientWidth;
    });
  },
  methods: {
    // 有预约已到的数据
    refresh(val) {
      if (val === '预约已到') {
        this.getTechnicianCardData();
      }
    },
    // 切换tab栏
    handleSelect() {
      this.getTechnicianCardData();
    },
    // 修改轮牌名称
    rcNameChange() {
      this.getTechnicianCardData();
    },
    // 修改轮牌项目
    rcProjectChange() {
      this.getTechnicianCardData();
    },
    // 选牌--扣牌，复牌，跳尾牌，下牌，上牌
    chooseCard(name) {
      const vm = this;
      if (name == '复牌') {
        if (vm.Lib.checkPower('beauty-2-lpkpfp') == false) return;
        const data = {
          id: vm.chooseTechnicianId
        };
        resumeCard(data).then((res) => {
          if (res.code == 0) {
            vm.getTechnicianCardData();
            vm.$message({ type: 'success', message: res.msg });
          } else {
            console.log(res);
          }
        });
      } else if (name == '跳尾牌') {
        if (vm.Lib.checkPower('beauty-2-lptwp') == false) return;
        const data = {
          id: vm.chooseTechnicianId
        };
        jumpCard(data).then((res) => {
          if (res.code == 0) {
            vm.getTechnicianCardData();
            vm.$message({ type: 'success', message: res.msg });
          } else {
            console.log(res);
          }
        });
      } else if (name == '上牌') {
        if (vm.Lib.checkPower('beauty-2-lpsp') == false) return;
        const data = {
          id: vm.chooseTechnicianId
        };
        upCard(data).then((res) => {
          if (res.code == 0) {
            vm.getTechnicianCardData();
            vm.$message({ type: 'success', message: res.msg });
          } else {
            console.log(res);
          }
        });
      } else {
        if (vm.Lib.checkPower('beauty-2-lpxp') == false) return;
        vm.cardDialog = true;
        vm.chooseCardName = name;
      }
    },
    // 提交事件--扣牌，下牌
    comfirmSubmit(formName) {
      const vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          if (vm.chooseCardName == '下牌') {
            if (vm.ruleForm.playCardType != '6' && !vm.ruleForm.leaveTime[0]) return;
            const data = {
              id: vm.chooseTechnicianId,
              startTime: vm.ruleForm.playCardType == '6' ? null : vm.ruleForm.leaveTime[0],
              endTime: vm.ruleForm.playCardType == '6' ? null : vm.ruleForm.leaveTime[1],
              message: vm.ruleForm.playCardType == '6' ? vm.ruleForm.playCardReason : vm.ruleForm.leaveReason,
              state: vm.ruleForm.playCardType
            };
            downCard(data).then((res) => {
              if (res.code == 0) {
                vm.getTechnicianCardData();
                vm.cardDialog = false;
                vm.$message({ type: 'success', message: res.msg });
              } else {
                console.log(res);
              }
            });
          } else {
            const data = {
              id: vm.chooseTechnicianId,
              message: vm.ruleForm.cardDeductionReason
            };
            deductCard(data).then((res) => {
              if (res.code == 0) {
                vm.getTechnicianCardData();
                vm.cardDialog = false;
                vm.$message({ type: 'success', message: res.msg });
              } else {
                console.log(res);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    getItemData() {
      const vm = this;
      const data = {
        mainId: window.sessionStorage.mainId
      };
      getItemByMainId(data).then((res) => {
        if (res.code == 0) {
          vm.itemList = res.data;
        } else {
          console.log(res);
        }
      });
    },
    // 统称轮牌数据
    getTechnicianCardData() {
      const vm = this;
      vm.loading = true;
      vm.roundCardList.cards = [];
      const data = {
        mainId: window.sessionStorage.mainId,
        itemId: vm.roundCardProject,
        state: vm.activeIndex,
        cardId: vm.roundCardId,
      };
      getErpTechnicianCard(data).then((res) => {
        if (res.code == 0) {
          vm.roundCardList = res.data;
          vm.loading = false;
        } else {
          console.log(res);
          vm.loading = false;
        }
      });
    },
    getBrandTypeList() {
      const vm = this;
      const data = {
        mainId: window.sessionStorage.mainId
      };
      getCardsByMainId(data).then((res) => {
        if (res.code == 0) {
          vm.brandTypeList = res.data;
        } else {
          console.log(res);
        }
      });
    },
    getTechnicianInfo(id, name, e, status) {
      const key = e.which; // 获取鼠标键位
      if (key == 1) { // (1:代表左键； 2:代表中键； 3:代表右键)
        this.getClassName = e.currentTarget.className;
        this.lastCardStatus = status;
        // 获取右键点击坐标
        const x = e.clientX + 10;
        const y = e.clientY + 8;
        $('#roundCardMenu').hide();
        if (this.getClassName == 'lfour' && this.lastCardStatus) return;
        $('#roundCardMenu').show().css({ left: x, top: y });
      }
      this.chooseTechnicianId = id;
      this.chooseTechnicianName = name;
    },
    // 隐藏轮牌事件菜单
    showMenu() {
      $('#roundCardMenu').hide();
    }
  }
};
</script>

<style>
.roundCard .el-tabs__nav {
    padding: 10px 0 4px 0;
}
#roundCardMenu {
    padding: 8px 0;
    width: 114px;
    border: 1px solid rgba(216, 220, 229, 1);
    box-shadow: 0px 2px 10px 0px rgba(53, 53, 53, 0.1);
    border-radius: 4px;
    background-color: #fff;
    z-index: 99999;
    position: absolute;
    cursor: pointer;
}

#roundCardMenu ul {
    width: 114px;
    list-style-type: none;
}

#roundCardMenu ul li {
    padding: 8px 15px;
    font-size: 14px;
    color: #666;
}
</style>
<style lang="less" scope>
.timer /deep/ i {
    font-style: normal;
}
.roundCardTabs {
    display: flex;
    align-items: center;
    p {
        width: 24px;
        height: 24px;
        border-radius: 2px;
        margin-right: 5px;
    }
    .cone {
        background: linear-gradient(
            -30deg,
            rgba(53, 214, 138, 1),
            rgba(93, 226, 155, 1)
        );
    }
    .ctwo {
        background: linear-gradient(
            -30deg,
            rgba(75, 156, 254, 1),
            rgba(117, 180, 255, 1)
        );
    }
    .cthree {
        background: linear-gradient(
            -30deg,
            rgba(255, 190, 53, 1),
            rgba(252, 225, 101, 1)
        );
    }
    .cfour {
        background: linear-gradient(
            0deg,
            rgba(204, 204, 204, 1),
            rgba(220, 220, 220, 1)
        );
    }
    .cfive {
        width: 22px;
        height: 22px;
        border: 1px solid #ccc;
    }
}
.roundCardlist {
    clear: both;
    ul {
        margin-bottom: 10px;
        clear: both;
        p {
            font-size: 14px;
            color: #333;
            height: 14px;
            line-height: 14px;
        }
        li {
            margin: 10px 20px 10px 0;
            width: 198px;
            height: 200px;
            border-radius: 10px;
            list-style-type: none;
            float: left;
            h1 {
                font-size: 18px;
                height: 18px;
                line-height: 18px;
                margin: 20px 20px 6px 20px;
                color: #fff;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            h2 {
                font-size: 14px;
                height: 32px;
                line-height: 16px;
                padding: 0 20px;
                color: #fff;
                word-break: break-all;
            }
            h6 {
                margin-top: 84px;
                width: 198px;
                height: 40px;
                line-height: 40px;
                background: rgba(0, 0, 0, 0.1);
                border-radius: 0px 0px 10px 10px;
                span {
                    font-size: 15px;
                    color: #fff;
                    padding-left: 20px;
                    width: 98px;
                    float: left;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                samp {
                    font-size: 15px;
                    color: #fff;
                    padding-right: 20px;
                    width: 60px;
                    float: right;
                    text-align: right;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                label {
                    font-size: 16px;
                    color: #333;
                    padding: 0 20px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
        .lone {
            background: linear-gradient(
                -30deg,
                rgba(53, 214, 138, 1),
                rgba(93, 226, 155, 1)
            );
        }
        .ltwo {
            background: linear-gradient(
                -30deg,
                rgba(255, 190, 53, 1),
                rgba(252, 225, 101, 1)
            );
        }
        .lthree {
            background: linear-gradient(
                0deg,
                rgba(204, 204, 204, 1),
                rgba(220, 220, 220, 1)
            );
        }
        .lfour {
            background: linear-gradient(
                -30deg,
                rgba(75, 156, 254, 1),
                rgba(117, 180, 255, 1)
            );
        }
        .lfive {
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(204, 204, 204, 1);
            h1 {
                color: #333;
            }
            h2 {
                color: #333;
            }
        }
    }
    ul:after {
        clear: both;
        display: table;
        content: "";
    }
}
.screen {
    float: left;
    font-size: 14px;
    margin-bottom: 20px;
}
.screenTwo {
  float: right;
  font-size: 14px;
  color: #333;
  display: flex;
  height: 40px;
  line-height: 40px;
  margin-bottom: 20px;
  .sp1 {
    display: block;
    float: left;
    margin: 10px 10px 10px 20px;
    width: 20px;
    height: 20px;
    background: linear-gradient(330deg, #35D68A 0%, #5DE29B 100%);
    border-radius: 50%;
  }
  .sp2 {
    display: block;
    float: left;
    margin: 10px 10px 10px 20px;
    width: 20px;
    height: 20px;
    background: linear-gradient(330deg, #4B9CFE 0%, #75B4FF 100%);
    border-radius: 50%;
  }
  .sp3 {
    display: block;
    float: left;
    margin: 10px 10px 10px 20px;
    width: 20px;
    height: 20px;
    background: linear-gradient(330deg, #FFBE35 0%, #FCE165 100%);
    border-radius: 50%;
  }
  .sp4 {
    display: block;
    float: left;
    margin: 10px 10px 10px 20px;
    width: 20px;
    height: 20px;
    background: linear-gradient(360deg, #CCCCCC 0%, #DCDCDC 100%);
    border-radius: 50%;
  }
  .sp5 {
    display: block;
    float: left;
    margin: 10px 10px 10px 20px;
    width: 18px;
    height: 18px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #CCCCCC;
    border-radius: 50%;
  }
}
.cardList {
    padding-bottom: 20px;
    li:first-child {
        height: 40px;
        line-height: 40px;
    }
    li {
        height: 60px;
        line-height: 60px;
        clear: both;
        list-style-type: none;
        .ll {
            width: 80px;
            float: left;
        }
        .lr {
            float: left;
        }
    }
}
</style>
